import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { AlertCircle } from "react-feather";
import { useTranslation } from "react-i18next";

const QRCodeConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onCancel}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 top-20 bg-black/30 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel id="qr-code-confirmation-modal" className="w-full max-w-lg transform overflow-hidden rounded-xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <div className="flex justify-center mb-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-yellow-100">
                    <AlertCircle className="w-6 h-6 text-yellow-600" />
                  </div>
                </div>

                <Dialog.Title
                  as="h3"
                  className="text-lg font-semibold leading-6 text-gray-900 text-center mb-2"
                >
                  {t("verify:qr_not_scannable")}
                </Dialog.Title>

                <div className="mt-4">
                  <p className="text-sm text-gray-600 font-medium text-center mb-4">
                    {t("verify:qr_scan_failed_ocr_prompt")}
                  </p>
                </div>
                <div className="bg-[#EAEBFF] rounded-[8px] p-3 mb-6">
                  <p className="text-xs text-gray-900">
                    <strong>{t("verify:whats_ocr")}</strong>
                    <br />
                    {t("verify:ocr_explanation")}
                  </p>
                </div>
                <div className="mt-6 flex gap-3">
                  <button
                    id="qr-code-confirmation-modal-cancel-button"
                    type="button"
                    onClick={onCancel}
                    disabled={isLoading}
                    className="flex-1 px-4 py-2.5 bg-gray-100 text-gray-900 font-medium rounded-[8px] hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors focus:outline-none"
                  >
                    {t("verify:cancel")}
                  </button>
                  <button
                    id="qr-code-confirmation-modal-proceed-button"
                    type="button"
                    onClick={onConfirm}
                    disabled={isLoading}
                    className="flex-1 px-4 py-2.5 bg-cfPrimary text-white font-medium rounded-[8px] hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
                  >
                    {isLoading && (
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    )}
                    {t("verify:proceed_with_ocr")}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default QRCodeConfirmationModal;
